import { Component } from '@theme/component';

/* Keep each gallery independent, including after native section rendering. */
if (!customElements.get('purrify-gallery')) {
  customElements.define('purrify-gallery', class extends Component {
    /** @param {MouseEvent} event */
    onGalleryClick(event) {
      const button = event.target;
      if (button instanceof HTMLButtonElement && button.closest('purrify-gallery') === this) {
        this.selectImage(button);
      }
    }

    /** @param {KeyboardEvent} event */
    onGalleryKeydown(event) {
      const button = event.target;
      if (!(button instanceof HTMLButtonElement) || button.closest('purrify-gallery') !== this) return;
      const buttons = [...this.querySelectorAll('[data-pmp-thumbnail]')];
      const index = buttons.indexOf(button);
      const rtl = getComputedStyle(this).direction === 'rtl';
      let next;
      if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + buttons.length) % buttons.length;
      else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + buttons.length) % buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else return;
      event.preventDefault();
      const target = buttons[next];
      if (!(target instanceof HTMLButtonElement)) return;
      this.selectImage(target);
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    /** @param {HTMLButtonElement} button */
    selectImage(button) {
      const image = this.querySelector('[data-pmp-main-image]');
      const stage = this.querySelector('[data-pmp-image-stage]');
      if (!(image instanceof HTMLImageElement) || !(stage instanceof HTMLElement) || !button.dataset.pmpImageSrc) return;
      stage.dataset.mode = button.dataset.pmpImageMode;
      image.src = button.dataset.pmpImageSrc;
      image.alt = button.dataset.pmpImageAlt || '';
      image.height = Number(button.dataset.pmpImageHeight) || 2048;
      for (const item of this.querySelectorAll('[data-pmp-thumbnail]')) {
        item.setAttribute('aria-pressed', String(item === button));
      }
      const status = this.querySelector('[data-pmp-image-status]');
      if (status) status.textContent = button.dataset.pmpStatusText || '';
    }
  });
}
